import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { ApplicationProvider } from 'context/AppContext';
import ApplicationThemeProvider from 'components/Theme';
import AppBar from 'components/AppBar';
import AppDrawer from 'components/Drawer';
import MainPanelLoader from 'components/MainPanelLoader';
import VersionBanner from 'components/VersionBanner';
import { BrowserRouter as Router } from "react-router-dom";
import { AuthProvider } from 'context/Auth';
import { GridsProvider } from 'context/GridsContext';
// if using cdn version, 'Msal' will be available in the global scope

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex'
  }
}))

function App() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Router>
        <AuthProvider>
          <ApplicationProvider>
            <ApplicationThemeProvider>
              <GridsProvider>
                <AppBar></AppBar>
                <AppDrawer></AppDrawer>
                <MainPanelLoader>
                </MainPanelLoader>
                <VersionBanner />
              </GridsProvider>
            </ApplicationThemeProvider>
          </ApplicationProvider>
        </AuthProvider>
      </Router>
    </div>
  );
}

export default App;
